import moment from "moment";
import { useEffect, useMemo, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { accountCargoFields } from "../../constants";
import * as calculatorActions from "../../containers/User/Calculator/actions";
import AddNewOrder from "../../containers/User/Orders/AddNewOrder";
import { capitalizeFirstLetter } from "../../utils";
import CustomAddModal from "../Common/CustomAddModal";
import CustomShowModal from "../Common/CustomShowModal";

function AccountCargoDetails(props) {
  const {
    calculatorData = {},
    setLoader = () => { },
    getInitalQueryAndFleetData = () => { },
    isFromSingleVesselCalcy = false,
    getInitialData = () => { },
    isFromCargoAnalysis,
    isContractEstimate = false,
    onClickEditCargoContract = () => { },
    IsEditable,
  } = props;

  const { portOperation = [], clientQuery = {} } = calculatorData || {};
  const { freightMode } = clientQuery;

  const [open, setOpen] = useState(false);
  const [selectedQuery, setSelectedQuery] = useState({});
  const [selectedPorts, setSelectedPorts] = useState([]);
  const [selectedPortsCommence, setSelectedPortsCommence] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const addQueryModalRef = useRef();
  const { id = "" } = useParams();

  useEffect(() => {
    setSelectedQuery(clientQuery);
    setSelectedPorts(
      portOperation.filter(
        (item) =>
          item.operation === "Loading" || item.operation === "Discharging"
      )
    );
  }, [calculatorData]);

  const onCloseModal = () => {
    setOpen(false);
    setIsEdit(false);
    setSelectedQuery({});
    setSelectedPorts([]);
  };

  const singleLoadingCargo = useMemo(() => {
    let singleLoadingCargo = {};
    let mixAdcom = "";
    let mixBrokerage = "";
    let mixOther = "";
    let mixTtlComm = "";
    let mixNetFrt = "";
    let mixStowFactor = "";
    if (Array.isArray(portOperation) && portOperation.length) {
      for (let i = 0; i < portOperation.length; i++) {
        if (portOperation[i].operation === "Loading") {
          if (!Object.keys(singleLoadingCargo).length)
            singleLoadingCargo = portOperation[i];
          mixAdcom = mixAdcom + (mixAdcom ? "/" : "") + (portOperation[i].adcom || "0");
          mixBrokerage = mixBrokerage + (mixBrokerage ? "/" : "") + (portOperation[i].brokerage || "0");
          mixOther = mixOther + (mixOther ? "/" : "") + (portOperation[i].other || "0");
          mixTtlComm = mixTtlComm + (mixTtlComm ? "/" : "") + (portOperation[i].ttlComm || "0");
          mixNetFrt = mixNetFrt + (mixNetFrt ? "/" : "") + (portOperation[i].netFrt || "0");
          mixStowFactor = mixStowFactor + (mixStowFactor ? "/" : "") + (portOperation[i].stowFactor || "0");
        }
      }
    }
    return {
      ...singleLoadingCargo,
      mixAdcom,
      mixBrokerage,
      mixOther,
      mixTtlComm,
      mixNetFrt,
      mixStowFactor,
    };
  }, [portOperation]);

  const onClickEditQuery = (query) => {
    setLoader(true);
    setSelectedQuery(query);
    const handleSuccess = (res) => {
      setLoader(false);
      setSelectedPorts(res.data?.cargoList?.filter((item) => item.operation !== "Commence") || []);
      setSelectedPortsCommence(res.data?.cargoList?.filter((item) => item.operation === "Commence") || []);
      setOpen(true);
      setIsEdit(true);
    };

    const handleError = () => setLoader(false);

    if (isContractEstimate) {
      if (!isFromSingleVesselCalcy) {
        calculatorActions.cargoByQuery(query._id).then(handleSuccess).catch(handleError);
      } else {
        calculatorActions.getEstimateContractById({ id }).then((res) => {
          setLoader(false);
          const cargoDetails = res?.data?.cargoContractDetails?.cargoDetails?.cargoList || [];
          setSelectedPorts(cargoDetails.filter((item) => item.operation !== "Commence"));
          setSelectedPortsCommence(cargoDetails.filter((item) => item.operation === "Commence"));
          setOpen(true);
          setIsEdit(true);
        }).catch(handleError);
      }
    } else if (!isFromSingleVesselCalcy) {
      calculatorActions.cargoByQuery(query._id).then(handleSuccess).catch(handleError);
    } else {
      calculatorActions.saveResultById(id).then((res) => {
        setLoader(false);
        const cargoList = res.data?.clientQuery?.cargoList || [];
        setSelectedPorts(cargoList.filter((item) => item.operation !== "Commence"));
        setSelectedPortsCommence(cargoList.filter((item) => item.operation === "Commence"));
        setOpen(true);
        setIsEdit(true);
      }).catch(handleError);
    }
  };

  const onSubmitConfirm = async () => {
    if (addQueryModalRef.current.onSubmitQuery) {
      const result = await addQueryModalRef.current.onSubmitQuery();
      if (result !== false) {
        getInitalQueryAndFleetData();
      }
    }
  };

  const onClickCreateCopy = async () => {
    if (addQueryModalRef.current.onSubmitQuery) {
      const result = await addQueryModalRef.current.onSubmitQuery(true);
      if (result !== false) {
        getInitalQueryAndFleetData();
      }
    }
  };

  return (
    <div className="w-full flex flex-col h-full bg-white" id="cargo-details">
      <div className="calculator-section-header cargo-details-header">
        <h4
          className="text-[12px] font-medium tracking-wide capitalize cursor-pointer m-0"
          style={{ color: "#ffffff", textDecoration: "underline" }}
          onClick={() => onClickEditQuery(clientQuery)}
        >
          Cargo Details
        </h4>
        {isContractEstimate && (
          <span
            className="text-[10px] font-medium cursor-pointer m-0"
            style={{ color: "#93c5fd", textDecoration: "underline" }}
            onClick={() => onClickEditCargoContract(true)}
          >
            View Contract
          </span>
        )}
      </div>

      {/* Body - Compact Table */}
      <div className="flex-1 overflow-auto">
        <table className="fleet-result-table cargo-details-table w-full">
          <tbody>
            {accountCargoFields.map((item, key) => {
              const mixKeys = ["adcom", "brokerage", "other", "ttlComm", "netFrt", "stowFactor"];
              const dateKeys = ["laycanStartDate", "laycanEndDate"];
              let displayValue = "-";

              if (mixKeys.includes(item.value)) {
                displayValue = singleLoadingCargo[`mix${capitalizeFirstLetter(item.value)}`];
              } else if (dateKeys.includes(item.value)) {
                displayValue = clientQuery[item.value]
                  ? moment(clientQuery[item.value]).format("DD/MMM/yyyy HH:mm")
                  : "";
              } else if (item.value === "freightMode") {
                displayValue = freightMode;
              } else if (item.value === "min" || item.value === "max") {
                displayValue =
                  clientQuery?.cargoList
                    ?.map((cargo) => Number(cargo?.[item.value]) || 0)
                    ?.reduce((sum, val) => sum + val, 0) ?? "-";
              }
              else {
                displayValue = clientQuery?.[item?.value] || "-";
              }

              return (
                <tr key={key}>
                  <th style={{ width: "42%", color: "#000000" }}>
                    {item.label}
                  </th>
                  <td className="text-left">{displayValue}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Modals Logic Remains Unchanged */}
      {IsEditable ? (
        <CustomAddModal
          open={open}
          title={isEdit ? "Update Cargo" : "New Cargo"}
          maxWidth="lg"
          saveLabel={isEdit ? "Update" : "Create"}
          addThirdBtn={isFromCargoAnalysis || isContractEstimate ? false : isEdit}
          thirdBtnAction={onClickCreateCopy}
          thirdBtnLabel="Create New Order"
          handleClose={onCloseModal}
          onSubmitConfirm={onSubmitConfirm}
          isDetailView={isFromCargoAnalysis}
        >
          <AddNewOrder
            isFromSingleVesselCalcy={isFromSingleVesselCalcy}
            ref={addQueryModalRef}
            setLoader={setLoader}
            onCloseModal={onCloseModal}
            selectedQuery={selectedQuery}
            selectedPorts={selectedPorts}
            selectedPortsCommence={selectedPortsCommence}
            isEdit={isEdit}
            setIsEdit={setIsEdit}
            getInitialData={getInitialData}
            isContractEstimate={isContractEstimate}
          />
        </CustomAddModal>
      ) : (
        <CustomShowModal
          open={open}
          title={"View Cargo"}
          maxWidth="lg"
          handleClose={onCloseModal}
        >
          <AddNewOrder
            isFromSingleVesselCalcy={isFromSingleVesselCalcy}
            ref={addQueryModalRef}
            setLoader={setLoader}
            onCloseModal={onCloseModal}
            selectedQuery={selectedQuery}
            selectedPorts={selectedPorts}
            selectedPortsCommence={selectedPortsCommence}
            isEdit={isEdit}
            setIsEdit={setIsEdit}
            getInitialData={getInitialData}
            isContractEstimate={isContractEstimate}
          />
        </CustomShowModal>
      )}
    </div>
  );
}

export default AccountCargoDetails;